import { BodyContent } from './layout/body'
import { HeadContent } from './layout/head'

export const OurStoryContent = () => {
  return (
    <div>
      <HeadContent />
      <BodyContent />
    </div>
  )
}
